var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"timer"}},[_c('v-progress-circular',{attrs:{"rotate":-90,"size":60,"width":5,"value":_vm.percentLeft,"color":_vm.color}},[_vm._v("\n    "+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }